import { ErrorPage } from '@components'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider } from 'antd'
import { useState } from 'react'

import { useSolutionsPage } from './hooks/useSolutionsPage'
import { CreateAutofillPageContainer } from './pages/createAutofill'
import { CreateFormPageContainer } from './pages/createForms'
import { MenuPageContainer } from './pages/menu/MenuPageContainer'
import { DataExportPage } from './pages/dataExport'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 300000
    }
  }
})

export const SolutionsPageContainer = () => {
  const { tarkenOrganizations, hasError } = useSolutionsPage()
  const [selectedMenu, setSelectedMenu] = useState<string>('menu')

  if (hasError) {
    return <ErrorPage />
  }

  // Mapeamento de menus para componentes
  const menuComponents = {
    'create-forms': (
      <CreateFormPageContainer
        setSelectMenu={setSelectedMenu}
        tarkenOrganizations={tarkenOrganizations}
      />
    ),
    'create-autofill': (
      <CreateAutofillPageContainer
        setSelectMenu={setSelectedMenu}
        tarkenOrganizations={tarkenOrganizations}
      />
    ),
    'data-export': (
      <DataExportPage setSelectMenu={setSelectedMenu} />
    ),
    'menu': (
      <MenuPageContainer setSelectMenu={setSelectedMenu} />
    )
  }

  // Renderiza o componente correspondente ao menu selecionado
  const content = menuComponents[selectedMenu as keyof typeof menuComponents] || menuComponents.menu

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorPrimary: '#FFC107',
            colorPrimaryHover: '#212121',
            colorPrimaryActive: '#FFC107',
            fontWeight: 'bold'
          }
        }
      }}>
      <QueryClientProvider client={queryClient}>{content}</QueryClientProvider>
    </ConfigProvider>
  )
}
